import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastMessage, ToastMessageService } from '../../../../core/services/toast-message.service';

/** Renders the toast queue. Mounted once in app.component. */
@Component({
  selector: 'app-toast-host',
  imports: [],
  template: `
    <div class="pointer-events-none fixed right-4 top-4 z-[1300] flex w-[calc(100vw-2rem)] max-w-sm flex-col gap-3" aria-live="polite">
      @for (toast of toasts.messages(); track toast.id) {
        <div
          role="status"
          class="pointer-events-auto flex items-start gap-3 rounded-xl border bg-white p-4 shadow-lg shadow-slate-900/10 dark:bg-slate-800"
          [class]="borderClass(toast)"
        >
          <i class="ic mt-0.5 shrink-0 text-lg" [class]="iconClass(toast)"></i>
          <div class="min-w-0 grow">
            @if (toast.summary) {
              <p class="m-0 text-sm font-semibold text-slate-900 dark:text-slate-100">{{ toast.summary }}</p>
            }
            @if (toast.detail) {
              <p class="m-0 mt-0.5 break-words text-sm text-slate-600 dark:text-slate-300">{{ toast.detail }}</p>
            }
          </div>
          <button
            type="button"
            class="inline-flex h-6 w-6 shrink-0 appearance-none items-center justify-center rounded-full border-0 bg-transparent text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 dark:hover:bg-slate-700"
            aria-label="Close"
            (click)="toasts.remove(toast.id!)"
          >
            <i class="ic ic-times text-xs"></i>
          </button>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ToastHostComponent {
  toasts = inject(ToastMessageService);

  iconClass(toast: ToastMessage): string {
    switch (toast.severity) {
      case 'success':
        return 'ic-check-circle text-green-600';
      case 'error':
        return 'ic-times-circle text-red-600';
      case 'warn':
        return 'ic-exclamation-triangle text-amber-500';
      default:
        return 'ic-info-circle text-sky-600';
    }
  }

  borderClass(toast: ToastMessage): string {
    switch (toast.severity) {
      case 'success':
        return 'border-green-200 dark:border-green-900';
      case 'error':
        return 'border-red-200 dark:border-red-900';
      case 'warn':
        return 'border-amber-200 dark:border-amber-900';
      default:
        return 'border-sky-200 dark:border-sky-900';
    }
  }
}
